import React from "react";
import {NavLink} from "react-router-dom";
import * as Utils from "../../inc/Utils";
import EntrepreneurSidebar from "./EntrepreneurSidebar";
import {Config} from "../../Config";
import toast, {Toaster} from "react-hot-toast";
import {confirmAlert} from "react-confirm-alert";
import moment from "moment-timezone";
import Select from 'react-select'

export default function EntrepreneurInfo(prop) {

    let member = prop.member;

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false);
    let [data, setData] = React.useState(null); 
    let [entrepreneurProduct, setEntrepreneurProduct] = React.useState('');
    let [entrepreneurProductId, setEntrepreneurProductId] = React.useState(null);
    let [entrepreneurType, setEntrepreneurType] = React.useState('');
    let [entrepreneurTypeId, setEntrepreneurTypeId] = React.useState(null);

    let refTitle = React.useRef();
    let refTitle_en = React.useRef();
    let refAddress = React.useRef();
    let refAddress_en = React.useRef();
    let refPhone = React.useRef();
    let refPhone_en = React.useRef();
    let refEmail = React.useRef();
    let refWebsite = React.useRef();
    let refGooglemapUrl = React.useRef();

    React.useEffect(() => {
        window.scrollTo(0, 0);

        document.title = 'ข้อมูลผู้ประกอบการ - NCSA';

        (async function() {
            try {
                if(member) {
                    const resEntrepreneurProduct = await getEntrepreneurProduct();
                    setEntrepreneurProduct(resEntrepreneurProduct.rows);
                    const resEntrepreneurType = await getEntrepreneurType();
                    setEntrepreneurType(resEntrepreneurType.rows);

                    const resView = await Utils.getEntrepreneurMember(member);

                    if(resView) {
                        setData(resView);

                        refTitle.current.value = resView.title ?? '';
                        refTitle_en.current.value = resView.title_en ?? '';
                        refAddress.current.value = resView.address ?? '';
                        refAddress_en.current.value = resView.address_en ?? '';
                        refPhone.current.value = resView.phone ?? '';
                        refPhone_en.current.value = resView.phone_en ?? '';
                        refEmail.current.value = resView.email ?? '';
                        refWebsite.current.value = resView.website ?? '';
                        refGooglemapUrl.current.value = resView.googlemapUrl ?? '';

                        if(resView.entrepreneurTypeId && resEntrepreneurType) {
                            setEntrepreneurTypeId(resEntrepreneurType.rows.filter(e => e.id === resView.entrepreneurTypeId)[0]);
                        }
                        if(resView.entrepreneurProductId && resEntrepreneurProduct) {
                            setEntrepreneurProductId(resEntrepreneurProduct.rows.filter(e => e.id === resView.entrepreneurProductId)[0]);
                        }
                    }
                }
            } catch (e) {
                //
            }
        })();

    }, []);

    async function getEntrepreneurProduct() {
        const response = await fetch(Config.apiUrl +'/entrepreneurProduct/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getEntrepreneurType() {
        const response = await fetch(Config.apiUrl +'/entrepreneurType/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onSubmit = () => {
        let title = refTitle.current.value;
        let title_en = refTitle_en.current.value;
        let address = refAddress.current.value;
        let address_en = refAddress_en.current.value;
        let phone = refPhone.current.value;
        let phone_en = refPhone_en.current.value;
        let email = refEmail.current.value;
        let website = refWebsite.current.value;
        let googlemapUrl = refGooglemapUrl.current.value;

        if(!entrepreneurTypeId) {
            toast.error("กรุณาระบุ ประเภท");
        }
        else if(!entrepreneurProductId) {
            toast.error("กรุณาระบุ ผลิตภัณฑ์");
        }
        else if(!title) {
            toast.error("กรุณาระบุ ชื่อผู้ประกอบการ");
            refTitle.current.focus();
        }
        else {
            confirmAlert({
                title: prop.lang === 'en' ? 'Alert':'แจ้งเตือน',
                message: prop.lang === 'en' ? 'Want to save information ?':'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: prop.lang === 'en' ? 'OK':'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            const body = {
                                title: title,
                                title_en: title_en,
                                slug: Utils.slugString(title + '-' + member.id),
                                currentSlug: data.slug,
                                entrepreneurTypeId: entrepreneurTypeId.id,
                                entrepreneurProductId: entrepreneurProductId.id,
                                address: address,
                                address_en: address_en,
                                phone: phone,
                                phone_en: phone_en,
                                email: email,
                                website: website,
                                googlemapUrl: googlemapUrl,
                                status: 1,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                            };
                            fetch(Config.apiUrl +'/entrepreneur/updateMember', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': member.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success(prop.lang === 'en' ? 'Save successfully':'บันทึกข้อมูลเรียบร้อย');
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: prop.lang === 'en' ? 'Cancel':'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onChangeEntrepreneurType = (Id) => {
        setEntrepreneurTypeId(Id);
    };

    const onChangeEntrepreneurProduct = (Id) => {
        setEntrepreneurProductId(Id);
    };

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <EntrepreneurSidebar active="info" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">

                            <div className="card-body p-0 px-xxl-3">
                                <h4 className="title-line-left mt-2 mb-3">{prop.lang === 'en' ? 'Entrepreneur':'ข้อมูลผู้ประกอบการ'}</h4>
                            </div>

                            <h6 className="pb-3">{prop.lang === 'en' ? 'Entrepreneur':'ข้อมูลผู้ประกอบการ'}</h6>

                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="th-tab" data-bs-toggle="tab"
                                            data-bs-target="#th" type="button" role="tab" aria-controls="th"
                                            aria-selected="true">ภาษาไทย
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="rn-tab" data-bs-toggle="tab"
                                            data-bs-target="#en" type="button" role="tab" aria-controls="en"
                                            aria-selected="false">English
                                    </button>
                                </li>
                            </ul>

                            <div className="tab-content mt-3" id="myTabContent">
                                <div className="tab-pane fade show active" id="th" role="tabpanel"
                                     aria-labelledby="th-tab">
                                    <div className="row g-3">
                                        <div className="col-12">
                                            <label htmlFor="permissionId" className="form-label">ประเภท <span className="text-danger">*</span></label>
                                            <Select
                                                isClearable={true}
                                                classNamePrefix="form-select-search"
                                                options={entrepreneurType}
                                                onChange={(event) => onChangeEntrepreneurType(event)}
                                                value={entrepreneurTypeId}
                                                getOptionValue={(option) => `${option.id}`}
                                                getOptionLabel={(option) => `${option.title}`}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <label htmlFor="entrepreneurProductId" className="form-label">ผลิตภัณฑ์ <span className="text-danger">*</span></label>
                                            <Select
                                                isClearable={true}
                                                classNamePrefix="form-select-search"
                                                options={entrepreneurProduct}
                                                onChange={(event) => onChangeEntrepreneurProduct(event)}
                                                value={entrepreneurProductId}
                                                getOptionValue={(option) => `${option.id}`}
                                                getOptionLabel={(option) => `${option.title}`}
                                            />
                                        </div>
                                        <div className="col-12">
                                            <label htmlFor="title" className="form-label">ชื่อผู้ประกอบการ <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" id="title" ref={refTitle} maxLength={250} />
                                        </div>
                                        <div className="col-12">
                                            <label htmlFor="address" className="form-label">ที่อยู่</label>
                                            <textarea className="form-control" id="address" ref={refAddress} maxLength={1000} rows={3}></textarea>
                                        </div>
                                        <div className="col-12">
                                            <label htmlFor="phone" className="form-label">เบอร์โทร</label>
                                            <input type="text" className="form-control" id="phone" ref={refPhone} maxLength={250} />
                                        </div>
                                        <div className="col-12">
                                            <label htmlFor="email" className="form-label">อีเมล</label>
                                            <input type="text" className="form-control" id="email" ref={refEmail} maxLength={250} />
                                        </div>
                                        <div className="col-12">
                                            <label htmlFor="website" className="form-label">เว็บไซต์</label>
                                            <input type="text" className="form-control" id="website" ref={refWebsite} maxLength={250} />
                                        </div>
                                        <div className="col-12">
                                            <label htmlFor="googlemapUrl" className="form-label">Google Map Url</label>
                                            <textarea className="form-control" id="googlemapUrl" ref={refGooglemapUrl} maxLength={1000} rows={5}></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane fade" id="en" role="tabpanel"
                                     aria-labelledby="en-tab">
                                    <div className="row g-3">
                                        <div className="col-12">
                                            <label htmlFor="title_en" className="form-label">ชื่อผู้ประกอบการ <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" id="title_en" ref={refTitle_en} maxLength={250} />
                                        </div>
                                        <div className="col-12">
                                            <label htmlFor="address_en" className="form-label">ที่อยู่</label>
                                            <textarea className="form-control" id="address_en" ref={refAddress_en} maxLength={1000} rows={3}></textarea>
                                        </div>
                                        <div className="col-12">
                                            <label htmlFor="phone_en" className="form-label">เบอร์โทร</label>
                                            <input type="text" className="form-control" id="phone_en" ref={refPhone_en} maxLength={250} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="buttons gap-15 pb-0 my-sm-4">
                                <button className="btn btn-primary w-130" type="button" onClick={onSubmit} disabled={isLoading}>
                                    <span className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {prop.lang === 'en' ? 'Update':'อัพเดต'}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 